/** The two places Tonight shows outside its page (2.D deliverable 9): a sidebar link and a Home card. */
import { flagsFromMe } from '@codex/contracts';
import { Button } from '@codex/ui';
import { useLocation } from '@tanstack/react-router';
import { NavLink } from '../../shell/nav-link.js';
import { useGoTo } from '../../shell/open-doc.js';
import { useShellSession } from '../../shell/session.js';
import { formatMinutes } from '../core/tonight-model.js';
import { useTonight } from '../queries.js';
import { NewSession } from './new-session.js';

function useSessionsOn(): boolean {
  const me = useShellSession();
  return me !== null && flagsFromMe(me).sessions === true;
}

export function TonightNavEntry(): React.JSX.Element | null {
  return useSessionsOn() ? <NavEntry /> : null;
}

function NavEntry(): React.JSX.Element {
  const pathname = useLocation({ select: (location) => location.pathname });
  return (
    <section className="cx-nav-section" aria-label="Tonight">
      <ul className="cx-nav-section__list">
        <li className="cx-nav-row-item">
          <NavLink
            href="/tonight"
            icon="moon"
            testId="shell.top.tonight"
            active={pathname === '/tonight' || pathname.startsWith('/tonight/')}
          >
            Tonight
          </NavLink>
        </li>
      </ul>
    </section>
  );
}

export function TonightHomeCard(): React.JSX.Element | null {
  const on = useSessionsOn();
  if (!on) return null;
  return <Card />;
}

function Card(): React.JSX.Element {
  const goTo = useGoTo();
  const tonight = useTonight();
  const data = tonight.data;
  return (
    <section className="cx-tonight-card" aria-label="Tonight">
      <h2>Tonight</h2>
      {data === undefined ? (
        <p className="cx-tonight__quiet">
          {tonight.isError ? "Tonight couldn't be loaded." : 'Loading Tonight.'}
        </p>
      ) : data.session === null ? (
        <>
          <p>No session is planned.</p>
          <NewSession
            nextNumber={data.nextNumber}
            onCreated={(id) => goTo(`/tonight?session=${id}`)}
          />
        </>
      ) : (
        <>
          <p className="cx-tonight-card__title">{data.session.document.title}</p>
          <p className="cx-tonight__meta">
            <span>
              {data.session.number === null ? 'No number yet' : `Session ${data.session.number}`}
            </span>
            <span>{`Status: ${data.session.status}`}</span>
            <span>{`${data.items.length} on the run sheet`}</span>
            <span>{`Planned: ${formatMinutes(data.plannedMinutes)}`}</span>
          </p>
          <Button icon="arrow-right" onClick={() => goTo('/tonight')}>
            Open Tonight
          </Button>
        </>
      )}
    </section>
  );
}
